import React, { useState, useEffect } from "react";
import produce from 'immer';
import auth from "../auth";
import globalState from '../state/GlobalState';
import { useState as useGlobalState } from '@hookstate/core';
import Version from "version";
import ServerState from '../controls/ServerState';
import ReactLoading from 'react-loading';
import { useConnect } from 'dotnetify';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Icon from "../components/Selfcare/Common/Icon";
import { Grid, Divider } from '@material-ui/core';
import { LargeButton, SmallButton } from '../controls/components/Buttons';
import { TextField } from '../controls/TextField';
import TextMaskAmount from '../components/Selfcare/TextMasks/TextMaskAmount';

export default function ViewPinPuk(props) {
    const { t } = useTranslation();
    const { vm, state } = useConnect("ViewPinPuk", {}, {
        headers: {
            Authorization: "Bearer " + auth.getAccessToken(),
            ClientVersion: Version.getVersion(),
            ServerToken: window.sessionStorage.ServerToken
        },
        vmArg: {
            SubscriptionNo: props.SubscriptionNo,
        },
        exceptionHandler: _ => auth.signOut()
    });
    const [localState, internalSetLocalState] = useState({ disabled: false, busy: false, termsAccepted: false, msisdn: '', amount: '' });
    const setLocalState = (o) => {
        internalSetLocalState(
            produce(draft => {
                draft[Object.keys(o)[0]] = Object.values(o)[0];
            })
        )
    }
    const gstate = useGlobalState(globalState);
    const theme = useTheme();

    return (
        <>
            <ServerState serverState={state} localState={localState} setLocalState={setLocalState} />
            {state.IsAdministrating && <div style={{ backgroundColor: 'black', color: 'white', padding: '5px', textAlign: 'center' }}><span dangerouslySetInnerHTML={{ __html: t('selfcare:info.now-administrating-number', { 0: state.AdministratedMsisdn }) }} /></div>}
            <div style={{ backgroundColor: theme.palette.primary.main, color: '#FFF', padding: '20px' }}>
                <Grid container justify="center">
                    <Grid item xs={12} sm={10}>
                        <Icon name="pin" size={48} color="#FFFFFF" />
                        <div style={{ fontSize: '20px', fontWeight: '700', maxWidth: '900px' }}>
                            PIN & PUK
                        </div>
                    </Grid>
                </Grid>
            </div>
            <form onSubmit={(e) => { e.preventDefault(); vm.$dispatch({ ValidateCharge: { amount: localState.amount, termsAccepted: localState.termsAccepted } }); setLocalState({ buzy: true }); }}>
                <Grid container direction="column" justify="space-around" alignItems="center" style={{ paddingTop: '17px' }}>
                    <Grid item xs={12} sm={10} style={{ width: '100%', padding: '0px 17px 17px 17px' }}>
                        <div dangerouslySetInnerHTML={{ __html: t('selfcare:dialog.pinpuksim', { statePin: state.Pin, statePuk: state.Puk, stateICC: state.ICC }) }} />
                    </Grid>
                    <Grid item xs={12} sm={10} style={{ width: '100%', padding: '0px 17px 17px 17px' }}>
                        <Grid container direction="column" justify="space-around" alignItems="center">
                            <LargeButton color="primary" style={{ marginRight: '14px' }} onClick={() => { props.handleClose(); }}> {t('selfcare:button.done')}</LargeButton>
                        </Grid>
                    </Grid>
                    {localState.buzy &&
                        <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '50px' }} >
                            <ReactLoading type={"bubbles"} color={theme.palette.primary.main} height={'50px'} width={'50px'} />
                        </div>
                    }
                </Grid>
            </form>
        </>
    );
}